{
  "actionbar.actions": "Radnje",
  "actionbar.actionsAvailable": "Dostupne radnje.",
  "actionbar.clearSelection": "Poništi odabir",
  "actionbar.selected": "Odabrano: { count }",
  "actionbar.selectedAll": "Sve odabrano",
  "actionbutton.pending": "u tijeku",
  "breadcrumbs.more": "Više stavki",
  "button.pending": "u tijeku",
  "calendar.invalidSelection": "{selectedCount, plural, one {Odabrani datum nije dostupan} other {Odabrani datumi nisu dostupni}}.",
  "combobox.loading": "Učitavam...",
  "combobox.loadingMore": "Učitavam još...",
  "combobox.noResults": "Nema rezultata",
  "contextualhelp.help": "Pomoć",
  "contextualhelp.info": "Informacije",
  "datepicker.endTime": "Vrijeme završetka",
  "datepicker.startTime": "Vrijeme početka",
  "datepicker.time": "Vrijeme",
  "dialog.alert": "Upozorenje",
  "dialog.dismiss": "Odbaci",
  "dropzone.replaceMessage": "Ispustite datoteku za zamjenu",
  "inlinealert.informative": "Informacije",
  "inlinealert.negative": "Pogreška",
  "inlinealert.notice": "Upozorenje",
  "inlinealert.positive": "Uspješno",
  "label.(optional)": "(opcionalno)",
  "label.(required)": "(obvezno)",
  "listview.loading": "Učitavam...",
  "listview.loadingMore": "Učitavam još...",
  "menu.loading": "Učitavam...",
  "menu.loadingMore": "Učitavam još...",
  "menu.moreActions": "Dodatne radnje",
  "menu.noResults": "Nema rezultata",
  "menu.unavailable": "Nije dostupno, proširi za detalje",
  "notificationbadge.indicatorOnly": "Nova aktivnost",
  "notificationbadge.plus": "{notifications}+",
  "picker.loading": "Učitavam...",
  "picker.loadingMore": "Učitavam još...",
  "picker.placeholder": "Odaberite…",
  "picker.selectedCount": "{count, plural, =0 {Nije odabrana nijedna stavka} one {Odabrana je # stavka} other {Odabrano je # stavki}}",
  "sidepanel.collapse": "Sklapanje bočnog panela",
  "sidepanel.expand": "Proširenje bočne ploče",
  "slider.maximum": "Najviše",
  "slider.minimum": "Najmanje",
  "table.cancel": "Poništi",
  "table.drag": "Povucite",
  "table.editCell": "Uredi ćeliju",
  "table.loading": "Učitavam...",
  "table.loadingMore": "Učitavam još...",
  "table.resizeColumn": "Promijeni veličinu stupca",
  "table.save": "Spremi",
  "table.sortAscending": "Sortiraj uzlazno",
  "table.sortDescending": "Sortiraj silazno",
  "tag.actions": "Radnje",
  "tag.hideButtonLabel": "Prikaži manje",
  "tag.noTags": "Nema",
  "tag.showAllButtonLabel": "Prikaži sve ({tagCount, number})",
  "toast.clearAll": "Poništi sve",
  "toast.collapse": "Sažmi",
  "toast.showAll": "Prikaži sve",
  "treeview.loadingMore": "Učitavam još..."
}
